import { Box, LinearProgress, Typography } from "@mui/material";
import { useEffect, useState } from "react";

const ProgressWithTimer = ({ duration, isCheckingComplete }) => {
  const [progress, setProgress] = useState(0);
  duration = duration * 1000; // Convert seconds to milliseconds

  useEffect(() => {
    if (isCheckingComplete) {
      setProgress(100);
      return;
    }

    const updateInterval = 100; // Update progress every 100ms
    const progressStep = (100 * updateInterval) / duration;

    const interval = window.setInterval(() => {
      setProgress((prevProgress) => {
        const nextProgress = prevProgress + progressStep;
        if (nextProgress >= 100) {
          window.clearInterval(interval);
          return 99;
        }
        return nextProgress;
      });
    }, updateInterval);

    return () => window.clearInterval(interval);
  }, [duration, isCheckingComplete]);

  return (
    <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
      <LinearProgress
        variant="determinate"
        value={isCheckingComplete ? 100 : Math.min(progress, 99)}
        style={{ width: "80%" }}
      />
      <Typography variant="body2">
        {isCheckingComplete ? 100 : Math.round(Math.min(progress, 99))}%
        completed
      </Typography>
    </Box>
  );
};

export default ProgressWithTimer;
